<template>
  <div>
    <Header/>

    <section id="main">
      <router-view></router-view>

      <section id="category-results">
        <div class="row clearfix">
          <h1>Individual Category Results</h1>
          <ul>
            <li v-for="cat in categories" :key="cat.id" :id="cat.id" :class="cat.id">
              <h3><router-link :to="{name:'Category', params:{catId: cat.id}}">{{ cat.title }}</router-link></h3>
            </li>
          </ul>
        </div>
      </section>

      <nav id="pages">
        <div class="row clearfix">
          <nav id="pages">
            <div class="row clearfix">
              <router-link :to="{name:'States'}" class="prev sixcol last">← States</router-link>
              <router-link :to="{name:'Appendix'}" class="next sixcol last">Appendix →</router-link>
            </div>
          </nav>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Categories',
  components: {
  },
  data () {
    return {
      categories: [
        {
          id: 'ballet-dance',
          title: 'Ballet and Dance',
        },
        {
          id: 'children-family',
          title: 'Children\'s/Family',
        },
        {
          id: 'classical-music',
          title: 'Classical Music',
        },
        {
          id: 'festivals-multi-category',
          title: 'Festivals (Multi-Category)',
        },
        {
          id: 'festivals-single-category',
          title: 'Festivals (Contemporary Music)',
        },
        {
          id: 'musical-theatre',
          title: 'Musical Theatre',
        },
        {
          id: 'contemporary-music',
          title: 'Contemporary Music',
        },
        {
          id: 'opera',
          title: 'Opera',
        },
        {
          id: 'special-events',
          title: 'Special Events',
        },
        {
          id: 'theatre',
          title: 'Theatre',
        },
        {
          id: 'circus-physical-theatre',
          title: 'Circus and Physical Theatre',
        },
        {
          id: 'comedy',
          title: 'Comedy',
        }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
<style lang="scss" scoped>
#category-results {
  .ballet-dance {
    background-image: url("~@/assets/img/2019/Dance-Locale---Coast-%28Maroubra%29%2C-Sydney-Dance-Company%2C-Daniel-Boud_SFW2.jpg");
  }
  .children-family {
    background-image: url("~@/assets/img/2019/Bluey's-Big-Play,-BBC-Studios,-Andrew-Kay-in-association-with-Queensland-Performing-Arts-Centre-and-Windmill-Theatre-Company,-Photo-Credit-Darren-Thomas_SFW.jpg");
  }
  .classical-music {
    background-image: url("~@/assets/img/2019/Luminous,-Courtesy-of-Australian-Chamber-Orchestra,-Julian-Kingma_SFW2.jpg");
  }
  .festivals-multi-category {
    background-image: url("~@/assets/img/2019/Velma-Celli's-A-Brief-History-of-Drag,-Fringe-World,-Kaifu-Deng_SFW2.jpg");
  }
  .festivals-single-category {
    background-image: url("~@/assets/img/2019/Nathaniel-Rateliff,-2019-Bluesfest,-Kurt-Peterson_SFW2.jpg");
  }
  .musical-theatre {
    background-image: url("~@/assets/img/2019/Jemma-Rix---Photo-by-Lisa-Tomasetti_SFW2.jpg");
  }
  .contemporary-music {
    background-image: url("~@/assets/img/2019/Queen-%2B-Adam-Lambert%2C-Fire-Fight-Australia%2C-Courtesy-of-TEG%2C-Photo-Credit---Jared-Leibowitz%5B2%5D_SFW.jpg");
  }
  .opera {
    background-image: url("~@/assets/img/2019/The-Selfish-Giant,-Victorian-Opera,-Charlie-Kinross_SFW.jpg");
  }
  .special-events {
    background-image: url("~@/assets/img/2019/CanbEurovision-2019,-Canberra-Theatre-Centre,-Martin-Ollmann_SFW.jpg");
  }
  .theatre {
    background-image: url("~@/assets/img/2019/Medea,-A-Black-Swan-State-Theatre-Company-of-WA-collaboration-with-WA-Youth-Theatre-Company,-Philip-Gostelow-35_SFW.jpg");
  }
  .circus-physical-theatre {
    background-image: url("~@/assets/img/2019/Leviathan,-Circa,-Johannes-Reinhart_SFW2.jpg");
  }
  .comedy {
    background-image: url("~@/assets/img/2019/Mawaan-Rizwan%2C-2019-Melbourne-International-Comedy-Festival%2C-Jim-Lee_SFW.jpg");
  }
}
</style>
